"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.storeAccessToken = storeAccessToken;
exports.loadAccessToken = loadAccessToken;
exports.removeAccessToken = removeAccessToken;
var constants_1 = require("../constants");
var DECIMAL_RADIX = 10;
function storeAccessToken(accessToken) {
    localStorage.setItem(constants_1.LOCAL_STORAGE_JWT, accessToken.jwt);
    localStorage.setItem(constants_1.LOCAL_STORAGE_JWT_EXPIRY, accessToken.expiryTimestamp.toString());
}
function loadAccessToken() {
    var jwt = localStorage.getItem(constants_1.LOCAL_STORAGE_JWT) || '';
    var expiryTimestamp = localStorage.getItem(constants_1.LOCAL_STORAGE_JWT_EXPIRY) || '';
    return {
        jwt: jwt,
        expiryTimestamp: parseInt(expiryTimestamp, DECIMAL_RADIX),
    };
}
function removeAccessToken() {
    localStorage.removeItem(constants_1.LOCAL_STORAGE_JWT);
    localStorage.removeItem(constants_1.LOCAL_STORAGE_JWT_EXPIRY);
}
//# sourceMappingURL=localStorageHelper.js.map